import { InjectionToken, Injector, Provider } from '@angular/core';
import { IconName } from '@fortawesome/fontawesome-svg-core';
import { LazyLoadComponentDef } from '@y42/core/lazy-load-component';
import { Y42FeatureType } from '@y42/json-schema';
import { Observable } from 'rxjs';
import { AbstractFeatureChildUIModel, AbstractFeatureUIModel, Asset } from '../../models';

export enum AssetSidebarTabType {
  Overview = 'overview',
  Metadata = 'metadata',
  Comment = 'comment',
  ACL = 'acl',
  Lineage = 'lineage',
  Delete = 'delete',
}

export interface AssetSidebarTab<
  T extends string = AssetSidebarTabType,
  C extends AssetSidebarTabComponent = AssetSidebarTabComponent,
> {
  type: T;
  label: string;
  logo: IconName;
  isFontAwesome?: true;
  featureType?: Y42FeatureType;
  componentDef: LazyLoadComponentDef<C>;
  hidden?: (asset: Asset | null, injector: Injector) => boolean;
}

export interface AssetSidebarTabComponent<
  _Asset extends AbstractFeatureUIModel | AbstractFeatureChildUIModel =
    | AbstractFeatureUIModel
    | AbstractFeatureChildUIModel,
> {
  // asset: Asset | undefined | null;
}

export const ASSET_SIDEBAR_FEATURE_COMPONENT_INDEX = 0;
export const ASSET_SIDEBAR_FEATURE_CHILD_COMPONENT_INDEX = 1;
export interface FeatureAssetSidebarComponentDefCollection<
  C extends AssetSidebarTabComponent = AssetSidebarTabComponent,
> {
  featureType: Y42FeatureType;
  // First element defines a feature component
  // Second element defines a feature child component
  componentDef: [LazyLoadComponentDef<C>] | [LazyLoadComponentDef<C>, LazyLoadComponentDef<C>];
}

export interface FeatureAssetSidebarComponentDef<C extends AssetSidebarTabComponent = AssetSidebarTabComponent> {
  featureType: Y42FeatureType;
  componentDef: LazyLoadComponentDef<C>;
}

export interface FeatureAssetSidebarComponent<
  Asset extends AbstractFeatureUIModel | AbstractFeatureChildUIModel =
    | AbstractFeatureUIModel
    | AbstractFeatureChildUIModel,
> extends AssetSidebarTabComponent<Asset> {
  readonly asset$: Observable<AbstractFeatureUIModel | AbstractFeatureChildUIModel | null | undefined>;
}

export const FEATURE_ASSET_SIDEBAR_COMPONENTS = new InjectionToken<FeatureAssetSidebarComponentDefCollection[]>(
  'Feature Asset Sidebar Components',
);

export function provideFeatureAssetSidebarComponent(component: FeatureAssetSidebarComponentDefCollection): Provider {
  return {
    provide: FEATURE_ASSET_SIDEBAR_COMPONENTS,
    useValue: component,
    multi: true,
  };
}
